//Third-party imports
import { Button, Grid, InputAdornment, TextField, Typography } from '@material-ui/core';
import { LoadingButton } from '@mui/lab';
import { Form, Formik } from 'formik';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { loadGridCustomer } from '../../helpers/loadGrid';
import { startNewClient } from '../../redux/actions/clients';
import { useFormStyles } from '../../styles/formStyles';
import { validationSchemaCustomer } from '../../utils/schemaValidationForm';
import { startLogOutContentModal } from '../../redux/actions/contentModal';
import { uiManageModalCollectionTypes } from '../../redux/actions/ui';
import { SwitchMUI } from '@/components/ui/Switch';
import { ApartmentOutlined } from '@material-ui/icons';
import { getCountries } from '@/redux/actions/countryService';
import { useAppSelector } from '@/hooks/useAppSelector';
import { StandardAutocomplete } from '@/components/ui/StandardAutocomplete';
import { ForceOtroDocumentoProbatorioEffect } from '@/helpers/formik-effects/forceOtroDocumentoProbatorioEffect';
import { shouldForceOtroDocumentoProbatorio } from '@/utils/nemonIntegration';

/**
 *
 * Author: QBK
 * Date: 30-09-2021
 */
export const ContentModalClientAdd = ({ simple }) => {
  const { data } = loadGridCustomer(simple);
  const classes = useFormStyles(); //the classes variable to handle the form styles
  const dispatch = useDispatch();

  const { countries } = useAppSelector(state => state.country);

  const countryOptions = countries.map(country => ({
    label: country.Nombre,
    value: country.PkPaises,
  }));

  useEffect(() => {
    dispatch(getCountries());
  }, [dispatch]);

  const initialValues = {
    Nombre: '',
    Apellidos: '',
    Email: '',
    Telefono: '',
    NumeroIdentificacionFiscal: '',
    Observaciones: '',
    OtroDocumentoProbatorio: false,
    Direccion: '',
    Numero: '',
    Piso: '',
    DireccionComplementaria: '',
    CodigoPostal: '',
    Municipio: '',
    Provincia: '',
    FkPaises: 69,
    EsEmpresa: false,
    ClienteTemporal: false,
    // TODO-af: Add IdNemon
  };

  const handleSubmit = (values, { setSubmitting }) => {
    const customer = {
      ...values,
    };
    dispatch(startNewClient(customer, setSubmitting));
  };

  const handleCancel = () => {
    dispatch(startLogOutContentModal());
    dispatch(uiManageModalCollectionTypes());
  };

  //HTML Grid Container
  return (
    <Formik initialValues={initialValues} validationSchema={validationSchemaCustomer} onSubmit={handleSubmit}>
      {({ values, handleChange, errors, handleBlur, isSubmitting, touched, isValid, setFieldValue }) => {
        const selectedCountry = countries.find(c => c.PkPaises === values.FkPaises);

        const forceOtroDocumentoProbatorio = selectedCountry
          ? shouldForceOtroDocumentoProbatorio(
              selectedCountry.Codigo,
              selectedCountry?.EsIntracomunitario,
              values.EsEmpresa,
            )
          : false;

        return (
          <Form>
            <ForceOtroDocumentoProbatorioEffect countries={countries} />
            <Grid item style={{ padding: '2rem' }}>
              <Grid container direction="column">
                <Grid item classes={{ root: classes.container }}>
                  <Typography variant="h1">Agregar Cliente</Typography>
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item md={4} xs={12} style={{ marginBottom: '2rem' }}>
                  <SwitchMUI label="Es empresa" name="EsEmpresa" values={values} setFieldValue={setFieldValue} />
                </Grid>
                <Grid item md={4} xs={12} style={{ marginBottom: '2rem' }}>
                  <SwitchMUI
                    label="Cliente temporal"
                    name="ClienteTemporal"
                    values={values}
                    setFieldValue={setFieldValue}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                {data.map(element => {
                  if (values.EsEmpresa && (element.name === 'Nombre' || element.name === 'Apellidos')) {
                    if (element.name === 'Apellidos') return null;
                    return (
                      <Grid md={12} item classes={{ root: classes.container }}>
                        <TextField
                          fullWidth
                          name={'Nombre'}
                          size="small"
                          classes={{ root: classes.inputText }}
                          id={`outlined-basic-${element.name}`}
                          label={'Razón social'}
                          variant="outlined"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <ApartmentOutlined />
                              </InputAdornment>
                            ),
                            classes: {
                              input: classes.resize,
                            },
                          }}
                          InputLabelProps={{ style: { fontSize: '0.8em' } }}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={touched['Nombre'] && Boolean(errors['Nombre'])}
                          helperText={touched['Nombre'] && errors['Nombre']}
                          disabled={isSubmitting}
                          required
                        />
                      </Grid>
                    );
                  }

                  if (element.name === 'FkPaises') {
                    return (
                      <Grid key={element.name} item md={6} xs={12}>
                        <StandardAutocomplete
                          name={element.name}
                          label={'País'}
                          value={values.FkPaises}
                          onChange={val => setFieldValue('FkPaises', Number(val))}
                          options={countryOptions}
                          required
                        />
                      </Grid>
                    );
                  }

                  const selectedCountry = countries.find(c => c.PkPaises === values.FkPaises);

                  const getDocumentoLabel = () => {
                    if (values.OtroDocumentoProbatorio) return 'ID';
                    if (values.EsEmpresa) {
                      if (selectedCountry.Codigo.toLowerCase() === 'es') return 'CIF';
                      if (selectedCountry?.EsIntracomunitario) return 'VAT Number';
                      return 'ID';
                    }
                    return selectedCountry?.Codigo.toLowerCase() === 'es' ? 'NIF' : 'ID';
                  };

                  if (element.name === 'NumeroIdentificacionFiscal') {
                    const getOtroDocumentoProbatorioLabel = () => {
                      if (selectedCountry?.Codigo?.toLowerCase() === 'es') {
                        return 'No censado';
                      }
                      return 'Otro documento probatorio';
                    };

                    return (
                      <>
                        <Grid item md={12} xs={12}>
                          <SwitchMUI
                            label={getOtroDocumentoProbatorioLabel()}
                            name="OtroDocumentoProbatorio"
                            values={values}
                            setFieldValue={setFieldValue}
                            style={undefined}
                            disabled={forceOtroDocumentoProbatorio}
                          />
                        </Grid>
                        <Grid xs={12} md={6} item classes={{ root: classes.container }}>
                          <TextField
                            fullWidth
                            name={element.name}
                            size="small"
                            classes={{ root: classes.inputText }}
                            id={`outlined-basic-${element.name}`}
                            label={getDocumentoLabel()}
                            variant="outlined"
                            InputProps={{
                              startAdornment: values.EsEmpresa ? (
                                <InputAdornment position="start">
                                  <ApartmentOutlined />
                                </InputAdornment>
                              ) : null,
                              classes: {
                                input: classes.resize,
                              },
                            }}
                            InputLabelProps={{ style: { fontSize: '0.8em' } }}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            error={touched[element.name] && Boolean(errors[element.name])}
                            helperText={touched[element.name] && errors[element.name]}
                            disabled={isSubmitting}
                            required={!values.ClienteTemporal}
                          />
                        </Grid>
                      </>
                    );
                  }

                  return (
                    <Grid
                      md={element.name === 'Direccion' || element.name === 'Observaciones' ? 12 : 6}
                      xs={12}
                      item
                      classes={{ root: classes.container }}>
                      <TextField
                        fullWidth
                        name={element.name}
                        size="small"
                        classes={{ root: classes.inputText }}
                        id={`outlined-basic-${element.name}`}
                        label={element.label}
                        variant="outlined"
                        InputProps={{
                          startAdornment: <InputAdornment position="start">{element.startAdornment}</InputAdornment>,

                          classes: {
                            input: classes.resize,
                          },
                        }}
                        InputLabelProps={{ style: { fontSize: '0.8em' } }}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={touched[element.name] && Boolean(errors[element.name])}
                        helperText={touched[element.name] && errors[element.name]}
                        disabled={isSubmitting}
                        multiline={element.name === 'Observaciones' ? true : false}
                        maxRows={element.name === 'Observaciones' ? 10 : undefined}
                        minRows={element.name === 'Observaciones' || element.name === 'Direccion' ? 3 : undefined}
                        required={
                          !values.ClienteTemporal
                            ? [
                                'Nombre',
                                'Apellidos',
                                'Telefono',
                                'NumeroIdentificacionFiscal',
                                'Direccion',
                                'CodigoPostal',
                                'FkPaises',
                                'Municipio',
                                'Provincia',
                              ].includes(element.name)
                            : ['Nombre', 'Apellidos', 'Telefono'].includes(element.name)
                        }
                      />
                    </Grid>
                  );
                })}
              </Grid>
              <Grid container spacing={3}>
                <Grid
                  xs={12}
                  fullWidth
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    p: 2,
                  }}>
                  <Button
                    style={{
                      marginRight: '20px',
                      backgroundColor: '#F39868',
                      color: '#fff',
                      borderRadius: 7,
                      marginLeft: 10,
                    }}
                    onClick={handleCancel}>
                    <Typography style={{ fontWeight: 'bold' }}>Cancelar </Typography>
                  </Button>

                  <LoadingButton
                    loadingPosition="start"
                    variant="contained"
                    type="submit"
                    loading={isSubmitting}
                    disabled={!isValid}
                    style={{
                      backgroundColor: '#E5824F',
                    }}>
                    Agregar
                  </LoadingButton>
                </Grid>
              </Grid>
            </Grid>
          </Form>
        );
      }}
    </Formik>
  );
};
